import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeedHistory } from './feed-history.model';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FeedHistoryService {
  private apiUrl = '/api/feed-history/';

  constructor(private http: HttpClient) {}

  public getFeedHistory(feedConfigurationId: string, tenantName: string): Observable<FeedHistory[]> {
    const url = `${this.apiUrl}${feedConfigurationId}/${tenantName}`;
    return this.http.get<FeedHistory[]>(url);
  }

  public retryFeedHistory(id: number, tenantName: string): Observable<void> {
    const url = `${this.apiUrl}${id}/retry/${tenantName}`;
    return this.http.post<void>(url, null);
  }

  public downloadFile(id: number, tenantName: string, fileName: string): Observable<void> {
    const url = `${this.apiUrl}${id}/download/${tenantName}`;
    return this.http.get(url, { responseType: 'blob' }).pipe(
      map(blob => this.saveBlob(blob, fileName || `feed-history-${id}`)));
  }

  private saveBlob(blob: Blob, fileName: string): void {
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  }
}
